<div  *ngIf="!isViewScreen">
  <div class="row ml-3 mt-2">
    <div class="col">
      <small *ngIf="accountCategory== 'RENTAL_FLEET'"><a [routerLink]="['/rental-fleet']" class="text-secondary">Admin
          Console</a>
        /<a [routerLink]="['/account-management']" class="text-secondary"> Account Management</a>
        /<a [routerLink]="['/service-packages']" class="text-secondary"> Service Package</a></small>
      <small *ngIf="accountCategory== 'FLEET_MANAGEMENT_COMPANY' || accountCategory == 'MOBILITY_COMPANY' || accountCategory == 'FIELD_SERVICE_COMPANY'"><a [routerLink]="['/commercial-fleet']"
          class="text-secondary">Admin Console</a>
        /<a [routerLink]="['/account-management']" class="text-secondary"> Account Management</a>
        /<a [routerLink]="['/service-packages']" class="text-secondary"> Service Package</a></small>
    </div>
  </div>
</div>

<div *ngIf="isViewScreen">
  <div class="row ml-3 mt-2">
    <div class="col">
      <small *ngIf="accountCategory== 'RENTAL_FLEET'"><a [routerLink]="['/rental-fleet']" class="text-secondary">Admin
          Console</a>
        /<a [routerLink]="['/account-management']" class="text-secondary"> Account Management</a>
        /<a [routerLink]="['/service-packages']" (click)="isViewScreen = false" class="text-secondary"> Service Package</a></small>
      <small *ngIf="accountCategory== 'FLEET_MANAGEMENT_COMPANY' || accountCategory == 'MOBILITY_COMPANY' || accountCategory == 'FIELD_SERVICE_COMPANY'"><a [routerLink]="['/commercial-fleet']"
          class="text-secondary">Admin Console</a>
        /<a [routerLink]="['/account-management']" class="text-secondary"> Account Management</a>
        /<a [routerLink]="['/service-packages']" (click)="isViewScreen = false" class="text-secondary"> Service Package</a></small>
        <small> 
          /<a class="text-secondary"> {{selectedPkgForView.name}}</a>  </small>
 
    </div>
  </div>
</div>


<div *ngIf="!isViewScreen">
  <div class="row pt-2 d-none d-sm-block">
    <div class="col-12 text-right">
      <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#importupdatePackage"
        data-backdrop="static" data-keyboard="false">Update Packages
        <!-- &nbsp;<span ><i class="fas fa-chevron-right"></i></span> -->
      </button>
    </div>
  </div>

  <div class="row mt-3 bg-light pb-1">
    <div class="col-lg-6 col-md-6 col-sm-6 col-6 text-center">
      <h5 class="mb-0">{{connectedVehicles}}</h5>
      <div>Connected Vehicles</div>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-6 col-6 align-center">
      <h5 class="mb-0">{{servicePackages.length}}</h5>
      <div>Service Packages</div>
    </div>
  </div>

  <div class="row mt-3 pb-2">
    <div class="table-responsive col-sm-12 no-gutter">
      <table class="table table-striped tbl-scrollable">
        <thead class="thead-light">
          <tr>
            <th scope="col" class="d-none d-xl-table-cell">Package ID</th>
            <th scope="col">Name</th>
            <!-- <th scope="col">Description</th> -->
            <th scope="col">Services</th>
            <th scope="col">Rate-Plan Type</th>

            <th scope="col">Consent</th>
            <th scope="col" class="text-center">Default</th>
            <th scope="col" class="hide-tbl-col">Applicability to Vehicles</th>
          </tr>
        </thead>
        <tbody class="max-height-57">
          <tr *ngFor="let package of servicePackages; let i = index">
            <td class="d-none d-xl-table-cell">{{package.servicePackageId}}</td>
            <td class="pointer" (click)="packageClickedForView(package)">{{package.name}}</td>
            <!-- <td>{{package.description}}</td> -->
            <td class="pointer" (click)="packageClickedForView(package)">
              <div *ngFor="let service of package.services; let j = index;">{{service.name | customText}}<span
                  *ngIf="j < (package.services.length - 1)">,&nbsp;</span></div>
            </td>
            <!-- <td>
            <span *ngFor="let service of package.services; let j = index;">{{service.name}}<span
                *ngIf="j < (package.services.length - 1)">,&nbsp;</span></span>
          </td> -->
          <td class="pointer" (click)="packageClickedForView(package)">
            <span>{{package.packageRatePlan.ratePlanType | customText}}</span> 
            <span>{{package.packageRatePlan.usageType | customText}}</span>
          </td>

            <td class="pointer" (click)="packageClickedForView(package)">
              <span *ngIf="package.consentRule && package.consentRule.endUserConsent && package.consentRule.traceability=='CONSENT_API'"> Per
                API </span>
              <span
                *ngIf="package.consentRule && package.consentRule.endUserConsent && package.consentRule.traceability=='OFFLINE_CONSENT_UPLOAD'">
                Offline Upload </span>
              <span *ngIf="package.consentRule && !package.consentRule.endUserConsent"> NA </span>
            </td>
            <td class="text-center">
              <span *ngIf="package.isDefault">Y</span>
              <span *ngIf="!package.isDefault">N</span>
            </td>
            <td class="hide-tbl-col">{{package.vehicles}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>


<div *ngIf="isViewScreen">
  <app-view-service-package [servicePackageData]="selectedPkgForView" [isShowEditbtn]="false"
    (submitEmitter)="submitButtonOfViewClicked($event)" (closeEmitter)="closeOfViewClicked($event)">
  </app-view-service-package>
</div>

<!-- Import udpate package/assing to vehicle model -->
<div class="modal fade" id="importupdatePackage" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="importupdatePackageTitle">Map/ Assign Service Packages to Vehicles</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form>
          <div class="form-group">
            <label>Upload UTF-8 Encoded Excel or CSV File</label>
            <div>
              <label>File Format</label>
            </div>
            <label class="mt-1">VIN (mandatory), ServicePackageId (mandatory), isDelete (optional)
              <br>
              isDelete - Boolean - if set to true, would delete the VIN-ServicePackageId mapping</label>
            <!-- <div class="custom-control custom-radio mt-2">
              <input type="radio" id="updatePackageDetailedEntry" name="updatePackageDetailedEntry"
                value="{{updatePackageImportEntryTypes[1]}}" [(ngModel)]="selectedupdatePackageEntryType"
                (change)="onupdatePackageEntryTypeSelected()" class="custom-control-input">
              <label for="detailedEntry" class="custom-control-label">Detailed Entry Format</label>
            </div>
            <label class="text-muted txt-small mt-3">VIN, Make, Model, Model-Year, Exterior Color, Telematics Type,, TSP
              Provider, TCU Manufacturer, TCU
              Type, IMEI ID, SIM ID, MSISDN, Subscription Type, Package IDs</label> -->
            <input class="hide" type="file" accept="image/*" (change)="onupdatePackageFileSelected($event)"
              #updatePackagefileInput>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light btn-80" data-dismiss="modal">CANCEL</button>
        <button type="button" class="btn btn-primary btn-80"
          (click)="updatePackagefileInput.click();uploadupdatePackageEntries()">UPLOAD</button>
      </div>
    </div>
  </div>
</div>

<!-- <input class="hide" #updatePackages name="updatePackages" type="file" /> -->